import React, { useState, useEffect, useMemo } from "react";
import RTE from "../../components/RTE";
import { useRef } from "react";
import { useWetReads } from "../../api/hooks/useWetReads";
import { useTranslation } from "react-i18next";

function WetReads({ study }) {
  const { t } = useTranslation('common');
  const editorRef = useRef(null);
  
  const [textInput, setTextInput] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [selectedStudyType, setSelectedStudyType] = useState("");
  
  const [checkedWetReads, setCheckedWetReads] = useState({});
  
  const { data: wetReadsData = [], isLoading: isLoadingWetReads } = useWetReads(
    study?.modalityId
  );

  const wetReadsByType = useMemo(() => {
    const groupedData = {};
    
    if (wetReadsData && wetReadsData.length > 0) {
      wetReadsData.forEach(wetRead => {
        const type = wetRead.studyType || "Unknown";
        
        if (!groupedData[type]) {
          groupedData[type] = [];
        }
        
        groupedData[type].push(wetRead);
      });
    }
    
    return groupedData;
  }, [wetReadsData]);
  
  const studyTypes = useMemo(() => {
    return Object.keys(wetReadsByType);
  }, [wetReadsByType]);
  
  useEffect(() => {
    if (study?.studyTypeWetRead && wetReadsData.length > 0) {
      const initialState = {};
      
      study.studyTypeWetRead.forEach(appliedWetRead => {
        wetReadsData.forEach((wetRead, index) => {
          if (wetRead.studyTypeId === appliedWetRead.studyTypeId) {
            initialState[wetRead.studyTypeId] = true;
          }
        });
      });
      
      setCheckedWetReads(initialState);
      
      if (studyTypes.length > 0 && !selectedStudyType) {
        setSelectedStudyType(studyTypes[0]);
      }
    }
  }, [study?.studyTypeWetRead, wetReadsData, studyTypes, selectedStudyType]);

  // const addTextToEditor = (text) => {
  //   if (!text.trim()) return;
    
  //   if (editorRef.current?.editor) {
  //     const editor = editorRef.current.editor;
  //     editor.insertHTML(text);
  //     setEditorContent(editor.getContents());
  //   } else {
  //     setEditorContent((prev) => prev + text);
  //   }
  // };

  // const handleCheckboxChange = (wetRead, isChecked) => {
  //   setCheckedWetReads(prev => ({
  //     ...prev,
  //     [wetRead.studyTypeId]: !isChecked
  //   }));
    
  //   if (!isChecked) {
  //     addTextToEditor(getWetReadDisplay(wetRead));
  //   }
  // };

  const resetForm = () => {
    setTextInput("");
    setEditorContent("");
    setSelectedStudyType(studyTypes.length > 0 ? studyTypes[0] : "");
    setCheckedWetReads({});
  };
  
  const getWetReadDisplay = (wetRead) => {
    if (!wetRead) return "No wet read available";
    return wetRead.worklistDisplay || wetRead.studyType || "Unnamed wet read";
  };
  
  const currentWetReads = useMemo(() => {
    if (!selectedStudyType) return [];
    return wetReadsByType[selectedStudyType] || [];
  }, [selectedStudyType, wetReadsByType]);
  
  console.log("wetReadsData", wetReadsData);
  console.log("wetReadsByType", wetReadsByType);
  console.log("study.studyTypeWetRead", study?.studyTypeWetRead);

  return (
    <div className="dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-3xl mt-10 p-2 shadow-sm dark:shadow-gray-900">
        <div className="bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2">
          <div>
            <h1 className="text-gray-900 dark:text-gray-100 font-semibold">Comments</h1>
          </div>
          <div className="px-3 mt-3">
            <textarea
              className="w-full p-3 rounded-3xl bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600"
              placeholder={t('addYourCommentsHere')}
              rows="6"
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
            ></textarea>
          </div>
        </div>
        
        <div className="flex flex-col bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2">
          <label htmlFor="study-type" className="text-gray-700 dark:text-gray-300 font-medium">{t('selectStudyType')}</label>
          <select
            id="study-type"
            className="sm:w-96 w-full border border-gray-300 dark:border-gray-600 p-3 rounded-full mt-3 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400 dark:focus:ring-green-600 cursor-pointer"
            value={selectedStudyType}
            onChange={(e) => setSelectedStudyType(e.target.value)}
          >
            <option value="" disabled className="cursor-not-allowed">
              {t('selectStudyType')}
            </option>
            {studyTypes.map((type) => (
              <option key={type} value={type} className="cursor-pointer">
                {type}
              </option>
            ))}
          </select>
        </div>
        
        <div className="bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2">
          <div>
            <h1 className="text-gray-900 dark:text-gray-100 font-semibold">{t('wetReadsFor')} {selectedStudyType || t('selectedType')}</h1>
            {isLoadingWetReads && <span className="ml-2 text-gray-700 dark:text-gray-300">{t('loading')}</span>}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
            {currentWetReads.map((wetRead) => (
              <div
                key={wetRead.studyTypeId}
                className={`p-2.5 xl:px-3 flex justify-between rounded-3xl sm:rounded-full h-auto sm:h-11 w-full place-content-center mt-3 ${
                  checkedWetReads[wetRead.studyTypeId] 
                    ? "bg-[#CBEA7B80] dark:bg-[#A4C63980] text-gray-800 dark:text-gray-200" 
                    : "bg-white dark:bg-gray-800 text-[#5F6368] dark:text-gray-300"
                } shadow-sm dark:shadow-gray-900`}
              >
                <h1 className="w-10/12">{getWetReadDisplay(wetRead)}</h1>
                <input
                  type="checkbox"
                  checked={!!checkedWetReads[wetRead.studyTypeId]}
                  disabled={true}
                  className="appearance-none h-4 w-4 mt-1 border-2 border-gray-600 dark:border-gray-400 rounded-full checked:bg-blue-500 dark:checked:bg-blue-600 checked:ring-2 checked:ring-blue-500 dark:checked:ring-blue-600 checked:ring-offset-2 dark:checked:ring-offset-gray-800"
                />
              </div>
            ))}
            
            {currentWetReads.length === 0 && !isLoadingWetReads && selectedStudyType && (
              <div className="col-span-2 text-center p-4 text-gray-700 dark:text-gray-300">
                {t('noWetReadsAvailable')}
              </div>
            )}
            
            {!selectedStudyType && !isLoadingWetReads && (
              <div className="col-span-2 text-center p-4 text-gray-700 dark:text-gray-300">
                {t('pleaseSelectStudyType')}
              </div>
            )}
          </div>
        </div>
        
        <div>
          <RTE
            name="wetReadsEditor"
            label=""
            heightValue={500}
            defaultValue=""
            value={editorContent}
            onChange={(content) => setEditorContent(content)}
            editorRef={editorRef}
          />
        </div>
        <div className="flex justify-end mt-4 space-x-3">
          <button
            className="border border-gray-300 dark:border-gray-600 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 h-10 rounded-full px-6 mt-2 hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 dark:focus:ring-gray-500"
            onClick={resetForm}
          >
            {t('reset')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WetReads;
